import {AddDataToCache, getCachedData} from "./caching";

const baseURL = "https://search-stacks-nhtjl6xzla-zf.a.run.app/api"
const API_KEY = "company-oppo-alpha-2026-xyz";

export async function getCities() {
    const cacheKey = `cache_cities`;
    const cachedResponse = await getCachedData(cacheKey);

    if (cachedResponse) {
        return cachedResponse;
    }
    return await fetch(`${baseURL}/getCitiesFilter`,{
    headers: { "X-API-Key": API_KEY }
    }).then(async (res) => {
        const responseData = await res.json();
        await AddDataToCache(cacheKey, responseData);
        return responseData;
    })
}
export async function getFiltersList() {
    const cacheKey = `cache_filters`;
    const cachedResponse = await getCachedData(cacheKey);

    if (cachedResponse) {
        return cachedResponse;
    }
    return await fetch(`${baseURL}/getFilters`, {
        headers: { "X-API-Key": API_KEY }
    }).then(async (res) => {
        const responseData = await res.json();
        await AddDataToCache(cacheKey, responseData);
        return responseData;
    })
}

export async function getAllCompanies() {
    const cacheKey = `all_companies`;
    const cachedResponse = await getCachedData(cacheKey);
    if (cachedResponse) {
        return cachedResponse.slice(0, 10); // Limit cached data to 10
    }
    return await fetch(`${baseURL}/getAllCompanies`, {
        headers: { "X-API-Key": API_KEY }
    }).then(async (res) => {
        const responseData = await res.json();
        // Limit to 10 companies before caching
        const limitedData = Array.isArray(responseData) 
            ? responseData.slice(0, 10) 
            : responseData;
        await AddDataToCache(cacheKey, limitedData);
        return limitedData;
    })
}

export async function searchAndFilter(token, filters) {
    let data = {
        "token": token,
        "filters": filters
    }
    const requestBody = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-API-Key': API_KEY
        },
        body: JSON.stringify(data)
    };
    const cacheKey = `cache_${JSON.stringify(data)}`;
    const cachedResponse = await getCachedData(cacheKey);

    if (cachedResponse) {
        return cachedResponse;
    }
    return await fetch(`${baseURL}/searchAndFilter`, requestBody).then(async (res) => {
        const responseData = await res.json();
        await AddDataToCache(cacheKey, responseData);
        return responseData;
    })
}
